var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEligible(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 67,
    height: 67,
    viewBox: "0 0 67 67",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 33.5,
    cy: 33.5,
    r: 33.5,
    fill: "#3377EF",
    fillOpacity: 0.08
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 20.4C23.2636 20.4 22.6667 20.9373 22.6667 21.6V46.4C22.6667 47.0627 23.2636 47.6 24 47.6H30.7188C30.5283 48.4773 30.7334 49.3172 31.2013 50H24C21.7909 50 20 48.3882 20 46.4V21.6C20 19.6118 21.7909 18 24 18H34.8192C35.6443 18 36.4356 18.295 37.0191 18.8201L47.5332 28.2828C48.1167 28.8079 48.4445 29.5201 48.4445 30.2627V30.8H48.2129C48.0163 30.7911 47.8193 30.7911 47.6227 30.8H37.7778C35.8141 30.8 34.2222 29.3673 34.2222 27.6V20.4H24ZM36.8889 22.0971V27.6C36.8889 28.0418 37.2869 28.4 37.7778 28.4H43.8922L36.8889 22.0971ZM47.9347 32.4H47.9384C48.9777 32.4004 50.0169 32.7575 50.8098 33.4711C52.3967 34.8993 52.3967 37.2149 50.8098 38.643L40.3166 48.0869C39.7048 48.6375 38.9383 49.0282 38.0989 49.217L34.8443 49.9493C33.429 50.2678 32.1469 49.1139 32.5008 47.8401L33.3144 44.911C33.5243 44.1555 33.9583 43.4656 34.5701 42.915L45.0633 33.4711C45.8562 32.7575 46.8954 32.4004 47.9347 32.4Z",
    fill: "#3377EF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEligible);
export default __webpack_public_path__ + "static/media/eligible.4e94c253bdde51ec8a9234d781065883.svg";
export { ForwardRef as ReactComponent };